'use strict';
import {NgFormUtil} from "../js/util/NgFormUtil";

{
    var app = angular.module('tf.game', ['tf.leaderboard', 'tf.introCourse', 'tf.game.service'])

        .controller('gameCtrl',
            ['$rootScope', '$scope', '$state', '$http', '$stateParams', 'userConfig', '$filter', 'terms', '$uibModal', '$localStorage', '$window', 'GoogleFeed', '$q', '$timeout', '$interval', '$document', 'confirmationService', 'confirmationTypes', 'gameLoss', 'leaderBoardService', 'asxGameService',
                function homeController($rootScope, $scope, $state, $http, $stateParams, userConfig, $filter, terms, $uibModal, $localStorage, $window, GoogleFeed, $q, $timeout, $interval, $document, confirmationService, confirmationTypes, gameLoss, leaderBoardService, asxGameService) {
            $localStorage.$default({
                gameHome : {
                    lastUpdate : new Date()
                }
            });

            $scope.CurrentDate = new Date();

            $scope.lastUpdate = new Date($localStorage.gameHome.lastUpdate).getTime();

            $state.userConfig = userConfig;

            $scope.vimeoConfig = {
                videoId: '265960632'
            };

            $scope.vimeoPlaceTradeConfig = {
                videoId: "303641214"
            };

            $scope.imgOption = 1;

            $scope.showImagePopover = function() {
                $scope.displayImage = true;
            };

            $scope.hideImagePopover = function() {
                $scope.displayImage = false;
            };

            $scope.openIntroVideo = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/game/partials/introVideo.tpl.html',
                    size: 'lg',
                    backdrop: 'static'
                });
            };

            $scope.openSplashGame = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/game/partials/introCourse/openSplash.tpl.html',
                    size: 'lg',
                    backdrop: 'static'
                });
            };

            $scope.openEducationPortal = function() {
                $window.open("/education", "_blank");
            };

            $scope.goToWizard = function() {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/game/partials/introCourse/openBuilderWizard.tpl.html',
                    controller: 'splashCtrl as splashCtrl',
                    size: 'lg',
                    backdrop: 'static',
                    resolve: {
                    }
                });
            };

            $scope.openTradingPortal = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/apps/tradingPortal/tradingPortal.tpl.html',
                    controller: 'tradingPortalCtrl as tradingPortalCtrl',
                    size: 'lg',
                    resolve: {
                    }
                });
            };

            $scope.openStockScreener = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/apps/stockScreener/stockScreener.tpl.html',
                    controller: 'stockScreenerCtrl as stockScreenerCtrl',
                    size: 'fs',
                    windowClass: 'fsModalScreener',
                    resolve: {
                        actionText : function() {
                            return 'View in Strategy Builder'
                        }
                    }
                });
                modalInstance.result.then(function(underlying) {
                    $state.go ("strategy", {underlying: underlying});
                });
            };

            $scope.openCookbook = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/apps/optionsCookbook/stockSelector.tpl.html',
                    controller: 'stockSelectorCtrl as stockSelectorCtrl',
                    size: 'lg',
                    resolve: {

                    }
                });
                modalInstance.result.then(function () {

                });
            };

            var profileFields = 0;
            var completedProfileFields = 0;
            Object.keys(userConfig.profile).forEach(function (key) {
                profileFields++;
                if (userConfig.profile[key]) {
                    completedProfileFields++;
                }
            });

            $scope.helpers = [
                {"name": "tcTV"},
                {"name": "optionsCourses"},
                {"name": "strategy"},
                {"name": "understandOptions"},
                {"name": "tcTV2"}
            ];

            $scope.profileSummary = {
                incomplete : completedProfileFields != profileFields,
                completeness : (completedProfileFields / profileFields) * 100,
                profile : userConfig.profile
            };

            $scope.xjoHistoryOptions = {
                type:'line',
                width:'55%',
                height:'100px',
                fillColor : false,
                minSpotColor: "#A90329",
                maxSpotColor: "green",
                lineColor : 'grey',
                lineWidth : 2,
                spotRadius : 2.5,
                spotColor: '#7f7f7f',
                highlightSpotColor: '#333333',
                highlightLineColor: '#333333',
                tooltipFormatter : function(sparkline, options, fields) {
                    return '<div class="jqsfield">' + $filter('date')($scope.xjoDates[fields.x], 'EEE dd/MM') + ' <br> ' + $filter('points')(fields.y, 2) + '</div>';
                }
            };

            function isLeague(leaderboard) {
                return leaderboard.type != 'SYSTEM';
            }

            $scope.leaderboardsAsAt = null;
            $scope.overallLeaderboard = null;
            $scope.leaderboards = [];
            $scope.leagues = [];

            $scope.updateLeaderBoard = function() {
                $http.get('/tradefloor/api/leaderboards?u=' + userConfig.id, {ignoreLoadingBar : true}).then(function (response) {

                    if ($scope.leaderboards.length && response.status === 304) {
                        return;
                    }

                    var data = response.data;
                    $scope.leaderboards = data.leaderboards;
                    $scope.leaderboardsAsAt = data.asAt;

                    $scope.leaderboards.forEach(function (l) {
                        if ((l.name === 'Professional' && l.you) || (l.name === 'Overall' && l.you)) {
                            $scope.overallLeaderboard = l;
                        }
                    });

                    $scope.leaderboards.forEach(addGap);

                    $scope.leagues = $scope.leaderboards.filter(isLeague);

                    function addGap(leaderboard) {

                        var currentRank = 0;

                        var gap = undefined;
                        for (var i = 0; i < leaderboard.leaders.length; i++) {
                            var rank = leaderboard.leaders[i].rank;
                            if (currentRank !== rank && rank !== (i + 1)) {
                                gap = i;
                                break;
                            }
                            currentRank = rank;
                        }

                        if (gap !== undefined) {
                            leaderboard.leaders.splice(gap, 0, {
                                gap: true
                            });
                        }
                    }
                });
            };

            $scope.updateLeaderBoard();

            var leaderBoardUpdateInterval = $interval(function() {
                var now = moment().tz('Australia/Sydney');

                var hour = now.hour();
                var isMarketHour = hour >= 10 && hour <= 17;

                var day = now.day();
                var isWeekday = day >=1 && day <=5;

                if (isWeekday && isMarketHour) {
                    $scope.updateLeaderBoard();
                }
            }, 300000);


            // Track if data is new
            $scope.lastCommentId = null;
            $scope.lastPostId = null;

            $scope.summary = true;

            $scope.post = {
                title : null,
                link : null,
                summary : null,
                promise : null
            };

            $scope.posts = [];
            $scope.lastCommentId = null;
            $scope.unallocatedComments = [];

            $scope.likePromise = null;

            $scope.likePost = function(post) {
                if (post.likePromise != null) {
                    return;
                }

                if (post.liked) {
                    post.likePromise = $http.delete('/tradefloor/api/posts/' + post.id + '/like').then(function(result) {
                        post.liked = !post.liked;
                        post.likes = post.likes - 1;

                    }).finally(function() {
                        post.likePromise = null;
                    });
                } else {
                    post.likePromise = $http.put('/tradefloor/api/posts/' + post.id + '/like').then(function(result) {
                        post.liked = !post.liked;
                        post.likes = post.likes + 1;
                    }).finally(function() {
                        post.likePromise = null;
                    });
                }
            };

            $scope.updatePost = function(p, form) {
                var post = {
                    summary : p.update.summary,
                    preview : p.update.preview,
                    title : p.update.title,
                    link : p.update.link
                };

                p.editing = false;

                p.update.promise = $http.put('/tradefloor/api/posts/' + p.id, post).then(function(response) {

                    p.title = post.title;
                    p.summary = post.summary;
                    p.preview = post.preview;
                    p.link = post.link;

                    form.$setPristine();
                    form.$setUntouched();
                    p.update.promise = null;
                }).finally(function() {
                    p.update.promise = null;
                });
            };

            $scope.postMessage = function() {
                var form = this.postForm;

                var post = {
                    summary : $scope.post.summary,
                    title : $scope.post.title,
                    link : $scope.post.link
                };

                $scope.post.promise = $http.post('/tradefloor/api/posts', post).then(function(response) {

                    $scope.post.summary = '';
                    $scope.post.title = null;
                    $scope.post.link = null;

                    form.$setPristine();
                    form.$setUntouched();
                    $scope.post.promise = null;

                    $scope.loadNewPosts();
                }).finally(function() {
                    $scope.post.promise = null;
                });
            };

            $scope.deletePost = function(post) {
                confirmationService.confirm(confirmationTypes.deletePost).then(function() {
                    $http.delete('/tradefloor/api/posts/' + post.id).then(function() {
                        $scope.posts = $scope.posts.filter(function(p) {
                            return p != post;
                        })
                    });
                });
            };

            $scope.toggleEditComment = function(comment) {
                comment.editing = !comment.editing;
                comment.summaryInput = comment.summary;
                // Hack to ensure the UI has updated and there is an element to focus on
                $timeout(function() {
                    var field = angular.element(document.getElementById('commentUpdate' + comment.id));
                    field.focus();
                }, 0);
            };

            $scope.showMoreComments = function(post) {
                post.limit += 5;
            };

            $scope.loadNewPosts = function() {
                // TODO update this to use a lastPostId
                if ($scope.posts.length) {
                    $http.get('/tradefloor/api/posts/after?post=' + $scope.posts[0].id, {ignoreLoadingBar : true}).then(function(response) {
                        var posts = response.data;

                        posts.forEach(function(post) {
                            post.comments = [];
                            post.limit = 0;
                            post.update = {
                                title: post.title,
                                summary: post.summary,
                                preview: post.preview,
                                link: post.link
                            }
                        });

                        $scope.posts = posts.concat($scope.posts);

                        $scope.loadNewComments();
                    });
                } else {
                    $http.get('/tradefloor/api/posts/latest', {ignoreLoadingBar : true}).then(function(response) {
                        var posts = response.data;

                        posts.forEach(function(post) {
                            post.comments = [];
                            post.limit = 1;
                            post.update = {
                                title: post.title,
                                summary: post.summary,
                                preview: post.preview,
                                link: post.link
                            };
                        });

                        $scope.posts = posts;

                        $scope.loadNewComments();
                    });
                }
            };

            $scope.loadNewPosts();

            $scope.maybeCancelUpdate = function($event, post, comment, updateCommentForm) {
                if (event.which == 27) {
                    $scope.cancelUpdate(post, comment, updateCommentForm);
                }
            };

            $scope.cancelUpdate = function(post, comment, updateCommentForm) {
                updateCommentForm.$setPristine();
                updateCommentForm.$setUntouched();

                comment.editing = false;
                comment.summaryInput = undefined;
            };
            $scope.updateComment = function(post, comment, form) {
                if (form.$invalid) {
                    return;
                }

                comment.editing = false;

                $http.post('/tradefloor/api/posts/' + post.id + '/comments/' + comment.id, comment.summaryInput).then(function() {
                    comment.summary = comment.summaryInput;
                    NgFormUtil.reset(form);
                });
            };

            $scope.deleteComment = function(post, comment) {
                $http.delete('/tradefloor/api/posts/' + post.id + '/comments/' + comment.id).then(function() {
                    post.comments = post.comments.filter(function(c) {
                        return c != comment;
                    });
                });
            };

            $scope.commentOnPost = function(post, form) {
                if (form.$invalid) {
                    return;
                }

                $http.put('/tradefloor/api/posts/' + post.id + '/comments', post.comment).then(function() {

                    $scope.loadNewComments();

                    post.comment = null;
                    NgFormUtil.reset(form);
                });
            };

            $scope.loadNewComments = function() {

                $http.get('/tradefloor/api/posts/comments' + ($scope.lastCommentId ? '?since=' + $scope.lastCommentId : ''), {ignoreLoadingBar : true}).then(function(response) {
                    var comments = response.data;

                    if (!comments.length) {
                        return;
                    }

                    $scope.lastCommentId = comments[0].id;

                    comments.reverse();

                    var postsById = {};

                    $scope.comments = comments.concat(comments);

                    $scope.unallocatedComments.forEach(function(comment) {
                        var post = postsById[comment.postId];
                        if (!post) {

                            $scope.posts.forEach(function(p) {
                                if (p.id == comment.postId) {
                                    post = p;
                                }
                            });

                            if (post) {
                                postsById[post.id] = post;
                            }
                        }

                        if (post) {
                            comment.post = post;
                            post.comments.unshift(comment);
                        }
                    });

                    $scope.unallocatedComments = $scope.unallocatedComments.filter(function (comment) {
                        return comment.post === undefined;
                    });

                    comments.forEach(function(comment) {
                        var post = postsById[comment.postId];
                        if (!post) {

                            $scope.posts.forEach(function(p) {
                                if (p.id == comment.postId) {
                                    post = p;
                                }
                            });

                            if (post) {
                                postsById[post.id] = post;
                            }
                        }

                        if (post) {
                            post.comments.unshift(comment);
                            comment.post = post;
                        } else {
                            $scope.unallocatedComments.unshift(comment);
                        }

                    });

                });
            };

            var newPostInterval = $interval(function() {
                $scope.loadNewPosts();

                $scope.lastUpdate = new Date($localStorage.gameHome.lastUpdate).getTime();
                $localStorage.gameHome.lastUpdate = new Date();

            }, 60000);

            $scope.defaultPortfolio = null;
            $rootScope.defaultPortfolio = null;
            $scope.portfolios = [];

            $scope.refreshPortfolios = function () {
                $http.get('/tradefloor/api/client/portfolios', {ignoreLoadingBar : true}).then(function(response) {
                    var data = response.data;
                    $scope.portfolios = data;

                    $scope.portfolios.forEach(function(p) {
                        p.todayMarginChange = p.clientMargin - p.todayMargin;
                        p.todayPnlChange = p.pnl - p.todayPnl;

                        p.weekMarginChange = p.clientMargin - p.weekMargin;
                        p.weekPnlChange = p.pnl - p.weekPnl;
                    });

                    if ($scope.portfolios.length) {
                        $scope.defaultPortfolio = $scope.portfolios[0];
                        $rootScope.defaultPortfolio = $scope.portfolios[0];

                        if ($scope.defaultPortfolio.status == 'SUSPENDED') {
                            gameLoss.open();
                        }
                    }
                });
            };

            $scope.refreshPortfolios();

            var refreshPortfolioInterval = $interval($scope.refreshPortfolios, 300000);

            asxGameService.dates().then(dates => $scope.gameOpens = dates.opens);

            $scope.$on('$destroy', function() {
                $interval.cancel(refreshPortfolioInterval);
                $interval.cancel(newPostInterval);
                $interval.cancel(leaderBoardUpdateInterval);
            });

        }]);
}
